import styled from "styled-components";
import "@splidejs/splide/dist/css/splide.min.css";
import { motion } from "framer-motion";
import { useState } from "react";
import { useSelector } from "react-redux";
import { projects } from "../data";

const WorkSlider = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [card, setCard] = useState({});
	const color = useSelector((state) => state.colorSlice.value);
	const expandOnFn = (id) => {
		setCard(projects.find((item) => item.id === id));
		setIsOpen(true);
		document.body.style.overflow = "hidden";
	};
	const expandOffFn = (e) => {
		if (e.target.classList.contains("layer")) {
			setIsOpen(false);
			document.body.style.overflow = "auto";
		}
	};
	return (
		<Slider>
			{projects
				.map(
					(item, index) =>
						item.active && (
							<Card key={index} layoutId={item.id}>
								<div className="img-container">
									<motion.img onClick={() => expandOnFn(item.id)} src={item.image} alt={item.title} layoutId={item.image} />
								</div>
								<motion.h3 layout="position" layoutId={item.title + item.id}>
									{item.title}
								</motion.h3>
							</Card>
						)
				)
				.reverse()}
			{isOpen && card.id && (
				<Layer className="layer" onClick={expandOffFn}>
					<OpenCard layoutId={card.id}>
						<motion.img style={{ pointerEvents: "auto" }} src={card.image} layoutId={card.image} />
						<Content animate={{ opacity: 1 }} initial={{ opacity: 0 }} exit={{ opacity: 0 }}>
							<motion.h3 layoutId={card.title + card.id}>{card.title}</motion.h3>
							<motion.p dangerouslySetInnerHTML={{ __html: card.description }} />
						</Content>
						{card.url && (
							<Btns animate={{ opacity: 1 }} initial={{ opacity: 0 }} exit={{ opacity: 0 }} color={color}>
								<a href={card.url} target="_blank" rel="noreferrer">
									<button>Live Demo</button>
								</a>
							</Btns>
						)}
					</OpenCard>
				</Layer>
			)}
		</Slider>
	);
};

export default WorkSlider;

const Slider = styled(motion.div)`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(3, auto);
	@media screen and (max-width: 1200px) {
		grid-template-columns: repeat(2, auto);
	}
	@media screen and (max-width: 700px) {
		grid-template-columns: repeat(1, auto);
	}
	gap: 2rem;
	padding: 2.3rem;
	justify-content: center;
`;
const Card = styled(motion.div)`
	max-width: 500px;
	border-radius: 1rem;
	box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
	background-color: #222;
	div.img-container {
		width: 100%;
		aspect-ratio: 16 / 9;
		border-radius: 1rem;
		overflow: hidden;
		img {
			width: 100%;
			object-fit: cover;
			border-radius: 1rem;
			cursor: pointer;
		}
	}
	h3 {
		margin: 1rem;
	}
`;
const Layer = styled(motion.div)`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
	z-index: 2;
	backdrop-filter: blur(5px);
	overflow-y: scroll;
	padding: 5rem 0;
`;
const OpenCard = styled(motion.div)`
	width: 60%; // for desktop
	@media screen and (max-width: 1200px) {
		width: 75%;
	} // for tablet
	@media screen and (max-width: 700px) {
		width: 80%;
	} // for mobile
	z-index: 3;
	cursor: auto;
	background-color: #222;
	border-radius: 1rem;
	box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
	img {
		width: 100%;
		border-radius: 1rem;
	}
`;
const Content = styled(motion.div)`
	margin: 1rem;
	h3 {
		font-size: 2rem;
	}
	p a {
		text-decoration: underline;
		font-weight: 600;
	}
`;
const Btns = styled(motion.div)`
	margin: 1rem;
	button {
		background-color: ${(props) => props.color};
		border: 1px solid ${(props) => props.color};
		padding: 10px 15px;
		font-size: 1.2rem;
		border-radius: 1rem;
		cursor: pointer;
	}
`;
